var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cadastro-simples-list',{attrs:{"endpoint":"tipo-passe","rota-base":"/admin/tipo-passe","titulo":"TIPOS DE PASSE","titulo-singular":"Tipo de Passe","colunas-extras":[{ campo: 'descricao', label: 'Descrição' }]}})
}
var staticRenderFns = []

export { render, staticRenderFns }